var data = {
	// Contents
	"content": {
		// Header
		"header": {
			"title":"糖尿病保腎護心<br class='dn-ns db'/>卓越機構",
			"subtitle":"快找你的控糖好厝邊"
		},
		"cover": {
			"title": "別以為糖尿病只是尿尿比較甜而已\n它也會攻擊腎臟和心臟",
			"content": "糖尿病殺手\n是如何攻擊\n腎和心的？\n快跟著我一起\n去瞧瞧吧！"
		},	
		"start": "開始",
		"car": {
			"clue": ["線索一","線索二"],
			"title": ["血管大塞車！\n原來跟糖尿病有關！","血管塞車可能會造成\n心衰竭或腎病變！"],
			"content": ["糖尿病患者血中的糖分太多，導致血液黏踢踢，<br class='db-l dn'/>容易引起發炎跟斑塊堆積，造成血管大塞車","不同血管的塞車會造成不同的問題：\n主幹道－心臟：心血管疾病\n次線道－腎臟：腎臟疾病\n因此，心衰竭和腎病變是糖尿病友們常見的共病！<sup>1,2</sup>"],
			"quote": ["讓我來告訴你\n血管塞車\n會怎樣～","那心衰竭和\n腎臟病又會\n造成什麼\n影響呢？"]
		},
    "test": {
      "title": "你「控」對了嗎 ? 有控糖不等於無風險 !\n 糖心腎一起看才完整 !",
    },
		"how": {
			"title": "快速了解心衰竭或腎病變會如何影響糖尿病友！",
			"card1": "心衰竭俗稱心臟無力，\n嚴重可能危及生命。\n對生活的常見影響還有：",
			"card1list": ["1. 呼吸困難","2. 耐力變差","3. 腦部缺氧","4. 水腫...等"],
			"card2": "腎病變則可能會導致\n糖尿病友需要洗腎！",
			"quote": "萬萬不可輕忽\n高血糖殺手啊！\n而且啊..." 
		},
		"cause": {
			"title": "糖尿病、心臟病、腎病變，都名列\n「國人十大死因」<sup>3</sup>",
			"top": ["第2名","第5名","第9名"],
			"content": ["心臟疾病","糖尿病","腎炎腎病症候群\n及腎病變"],
			"quote": "到底是誰和糖尿病殺手\n一起造成心衰竭或\n腎病變呢？" 
		},
		"knowledge": {
			"title": "知己知彼，百戰百勝\n一起對抗糖尿病殺手的盟友們！",
			"cardtitle": ["高血壓","蛋白尿"],
			"cardcontent1": [
				"<p class='f24_'>血壓值高於\n130/80 mmHg</p><p class='f32 fw5'>每10個糖尿病患就有6個合併高血壓</p>",
				"<p class='f24_'>尿中蛋白質排出量大於\n150毫克</p><p class='f32 fw5'>每10個糖尿病患就有3個合併蛋白尿</p>",
			],
			"cardcontent2": [
				"<p class='f24_'>高血壓為心衰竭\n主要風險因子</p>",
				"<p class='f24_'>蛋白尿同時為心衰竭以及\n腎臟惡化的主要風險因子</p>",
			],
			"cardcontent3": [
				"<p class='f32 fw5'>糖尿病+高血壓<br/>＝心衰竭風險增加2倍<sup>4,5</sup><br/><br/></p>",
				"<p class='f32 fw5'>糖尿病+蛋白尿<br/>＝腎臟惡化風險快3倍，可能會洗腎！<sup>6</sup></p>",
			],
			"cardcontent4": [
				"<p class='f32 fw5 mb0'>糖尿病+心衰竭<br/>＝死亡風險增加10倍<sup>7</sup></p>",
				"<p class='f32 fw5 mb0'>糖尿病+腎病變<br/>＝死亡風險增加1.2倍<sup>8</sup><br/>而且要洗腎！</p>",
			],
			"banner": "奸詐的殺手們，居然還會互相合作！\n高血壓可能導致要洗腎，蛋白尿也會升高心衰竭風險。",
			"quote": "別擔心！我有辦法！\n首先，要知道自己\n有沒有心臟病/腎臟病？"
		},
		"factor": {
			"title": "你有這些風險因子嗎",
			"subtitle": "如果有以下風險因子的糖友，更可以到糖尿病保腎護心卓越機構篩檢並接受專業諮詢！",
			"factors": [
				"高血壓",
				"蛋白尿",
				"高血脂",
				"抽菸",
				"肥胖",
				"心血管\n疾病",
				"家族成員有\n心血管疾病",
				"家族成員有\n慢性腎臟病"
			],
			"banner": "其他併發症（如眼睛和腳部）也不可以輕忽喔！",
			"quote": "有其他問題嗎？\n讓我來解答！"
		},
		"qa": {
			"title": "常見Q&A",
			"question": [
				"我是糖友/高風險群，該怎麼辦？",
				"糖尿病保腎護心卓越機構是什麼?",
				"到糖尿病保腎護心卓越機構有什麼好處？"
			],
			"answercontent": [
				"<p class='tc'>平時有良好的血糖/血脂/血壓控制、戒菸，<br class='db-l dn'/>搭配適合的運動及飲食外，也可以到<strong>「糖尿病保腎護心卓越機構」</strong><br class='db-l dn'/>接受風險因子篩檢，並由專業醫護團隊提供您照護諮詢\n請認明品質認證標章～</p>",
				"<p class='tl'>卓越機構皆通過以下認證規則：\n<strong>1. 治療觀念與時俱進：</strong>認證診所每年皆須參與協會認定之糖尿病治療課程\n<strong>2. 風險評估超前部署：</strong>診所糖友多數均接受腎心風險因子篩檢\n<strong>3. 重點衛教及時介入：</strong>經篩檢評估後，對於自身腎心風險因子有認知落差的糖友，醫師能及時介入治療</p>",
				"<p class='tl'>糖友可以接受\n<strong>1. 專業照護：</strong>享受最專業的糖尿病治療團隊照護\n<strong>2. 風險篩檢：</strong>接受「糖尿病腎心風險因子」篩檢\n<strong>3. 及時諮詢：</strong>最新觀念的衛教與專業醫護人員諮詢</p>"
			]
		},
		"map": {
			"title": "要怎麼找到糖尿病保腎護心卓越機構？"
		},
		"banner": "如果有飲食、生活習慣、糖尿病用藥建議等問題\n都可以請教您的醫師與照護團隊喔！\n讓我們作伙控血糖～",
		"footer": {
			"title": "Reference",
			"list": [
				"2018糖尿病臨床照護指引(含2020修訂版)。2020出版。社團法人中華民國糖尿病學會。",
				"2019台灣糖尿病腎臟疾病臨床照護指引。社團法人中華民國糖尿病學會。",
				"108年國人死因統計結果。衛生福利部 https://www.mohw.gov.tw/cp-16-54482-1.html",
				"J Community Hosp Intern Med Perspect. 2017;7(1):15-20.",
				"Mayo Clin Proc. 2020;95(1):124-133.",
				"Diabetes Care. 202;43(1):122-129.",
				"Diabetologia. 2012;55:2154-2162.",
				"臺灣糖尿病年鑑2019第二型糖尿病。社團法人中華民國糖尿病學會。",
				"2007 年台灣地區高血壓、高血糖、 高血脂之追蹤調查研究。行政院衛生署國民健康局。",
				"Circulation. 2019;139(25):e1082-e1143.",
				"J Formos Med Assoc. 2017;116(4):217-248.",
				"Diabetes and Chronic Kidney Disease. National Kidney Foundation. https://www.kidney.org/news/newsroom/factsheets/Diabetes-And-CKD",
				"Diabetes Care 2020;43(1):122-129."
			]
		}
	},
	// Maps
	"map": [
  {
    "id": 1,
    "name": "彗恩診所",
    "city": "keelung-city",
    "address": "基隆市中正區基隆市中正區義二路125號1樓",
    "phone": "(02) 24289337",
    "illustration": [
      "1彗恩診所.png"
    ]
  },
  {
    "id": 2,
    "name": "康合診所",
    "city": "keelung-city",
    "address": "基隆市暖暖區源遠路281之1號",
    "phone": "(02) 24592200",
    "illustration": [
      "2康合診所.png"
    ]
  },
  {
    "id": 3,
    "name": "正光診所",
    "city": "keelung-city",
    "address": "基隆市七堵區南興路12號",
    "phone": "(02) 24569275",
    "illustration": [
      "3正光診所.png"
    ]
  },
  {
    "id": 4,
    "name": "紀醫師診所",
    "city": "keelung-city",
    "address": "基隆市七堵區開元路83號",
    "phone": "(02) 24554195",
    "illustration": [
      "4紀醫師診所.png"
    ]
  },
  {
    "id": 5,
    "name": "陳炳堅診所",
    "city": "taipei-city",
    "address": "台北市松山區延壽街327號",
    "phone": "(02) 27637199",
    "illustration": [
      "5陳炳堅診所.png"
    ]
  },
  {
    "id": 6,
    "name": "吳慶南內科診所",
    "city": "taipei-city",
    "address": "台北市松山區民生東路五段138號",
    "phone": "(02) 27659566",
    "illustration": [
      "6吳慶南內科診所.png"
    ]
  },
  {
    "id": 7,
    "name": "自在診所",
    "city": "taipei-city",
    "address": "台北市信義區中坡南路84號",
    "phone": "(02) 27268199",
    "illustration": [
      "7自在診所.png"
    ]
  },
  {
    "id": 8,
    "name": "松山班廷建興診所",
    "city": "taipei-city",
    "address": "台北市信義區市民大道六段318號",
    "phone": "(02) 27652295",
    "illustration": [
      "8松山班廷建興診所.png"
    ]
  },
  {
    "id": 9,
    "name": "銘人診所",
    "city": "taipei-city",
    "address": "台北市中正區博愛路9號3樓",
    "phone": "(02) 77557566",
    "illustration": [
      "9銘人診所.png"
    ]
  },
  {
    "id": 10,
    "name": "哲民診所",
    "city": "taipei-city",
    "address": "台北市中山區龍江路356巷24號",
    "phone": "(02) 25026854",
    "illustration": [
      "clinics.png"
    ]
  },
  {
    "id": 11,
    "name": "沈德昌診所",
    "city": "taipei-city",
    "address": "台北市大安區四維路189號",
    "phone": "(02) 27035300",
    "illustration": [
      "clinics.png"
    ]
  },
  {
    "id": 12,
    "name": "榮陽安心診所",
    "city": "taipei-city",
    "address": "台北市北投區自強街168號",
    "phone": "(02) 28211566",
    "illustration": [
      "12榮陽安心診所_1.png",
      "12榮陽安心診所_2.png",
      "12榮陽安心診所_3.png"
    ]
  },
  {
    "id": 13,
    "name": "福田診所",
    "city": "new-tp-city",
    "address": "新北市蘆洲區中正路 140 號",
    "phone": "(02) 82863287",
    "illustration": [
      "13福田診所.png"
    ]
  },
  {
    "id": 14,
    "name": "大安診所",
    "city": "new-tp-city",
    "address": "新北市蘆洲區長安街283號",
    "phone": "(02) 82857182",
    "illustration": [
      "14大安診所.png"
    ]
  },
  {
    "id": 15,
    "name": "丁良文內科診所",
    "city": "new-tp-city",
    "address": "新北市蘆洲區長安街30號",
    "phone": "(02) 82822809",
    "illustration": [
      "15丁良文內科診所.png"
    ]
  },
  {
    "id": 16,
    "name": "常春聯合診所",
    "city": "new-tp-city",
    "address": "新北市板橋區四川路一段47號",
    "phone": "(02) 29642694",
    "illustration": [
      "16常春聯合診所.png"
    ]
  },
  {
    "id": 17,
    "name": "翰生診所",
    "city": "new-tp-city",
    "address": "新北市板橋區漢生西路73號",
    "phone": "(02) 22545665",
    "illustration": [
      "17翰生診所.png"
    ]
  },
  {
    "id": 18,
    "name": "樂欣診所",
    "city": "new-tp-city",
    "address": "新北市板橋區四維路108號",
    "phone": "(02) 22526222",
    "illustration": [
      "18樂欣診所.png"
    ]
  },
  {
    "id": 19,
    "name": "陳敏玲內科診所",
    "city": "new-tp-city",
    "address": "新北市板橋區溪崑二街97號",
    "phone": "(02) 26816661",
    "illustration": [
      "19陳敏玲內科診所.png"
    ]
  },
  {
    "id": 20,
    "name": "重心診所",
    "city": "new-tp-city",
    "address": "新北市板橋區國慶路189號",
    "phone": "(02) 29597755",
    "illustration": [
      "clinics.png"
    ]
  },
  {
    "id": 21,
    "name": "大川診所",
    "city": "new-tp-city",
    "address": "新北市板橋區中山路二段84之6號",
    "phone": "(02) 89532285",
    "illustration": [
      "21大川診所.png"
    ]
  },
  {
    "id": 22,
    "name": "春和診所",
    "city": "new-tp-city",
    "address": "新北市板橋區長江路一段138號",
    "phone": "(02) 22560068",
    "illustration": [
      "22春和診所.png"
    ]
  },
  {
    "id": 23,
    "name": "大鈞診所",
    "city": "new-tp-city",
    "address": "新北市板橋區中山路二段88號",
    "phone": "(02) 29646656",
    "illustration": [
      "23大鈞診所.png"
    ]
  },
  {
    "id": 24,
    "name": "安濟診所",
    "city": "new-tp-city",
    "address": "新北市樹林區中華路162號",
    "phone": "(02) 86841966",
    "illustration": [
      "clinics.png"
    ]
  },
  {
    "id": 25,
    "name": "五股水碓診所",
    "city": "new-tp-city",
    "address": "新北市五股區自強路36號",
    "phone": "(02) 22921516",
    "illustration": [
      "25五股水碓診所.png"
    ]
  },
  {
    "id": 26,
    "name": "中和班廷謝安慈診所",
    "city": "new-tp-city",
    "address": "新北市中和區中山路二段210號",
    "phone": "(02) 22401726",
    "illustration": [
      "26中和班廷謝安慈診所.png"
    ]
  },
  {
    "id": 27,
    "name": "凱程診所",
    "city": "new-tp-city",
    "address": "新北市中和區員山路150之8號1樓",
    "phone": "(02) 22231868",
    "illustration": [
      "27凱程診所.png"
    ]
  },
  {
    "id": 28,
    "name": "博新小兒科家醫科診所",
    "city": "new-tp-city",
    "address": "新北市永和區仁愛路24號",
    "phone": "(02) 32334150",
    "illustration": [
      "28博新小兒科家庭醫學科診所.png"
    ]
  },
  {
    "id": 29,
    "name": "惠恩診所",
    "city": "new-tp-city",
    "address": "新北市永和區保安路77號",
    "phone": "(02) 29249333",
    "illustration": [
      "29惠恩診所.png"
    ]
  },
  {
    "id": 30,
    "name": "安禾聯合診所",
    "city": "new-tp-city",
    "address": "新北市三重區中華路89號",
    "phone": "(02) 29820632",
    "illustration": [
      "30安禾聯合診所.png"
    ]
  },
  {
    "id": 31,
    "name": "九如聯合診所",
    "city": "new-tp-city",
    "address": "新北市三重區仁愛街753號",
    "phone": "(02) 28575600",
    "illustration": [
      "31九如聯合診所_1.png",
      "31九如聯合診所_2.png",
      "31九如聯合診所_3.png"
    ]
  },
  {
    "id": 32,
    "name": "李瑞相診所",
    "city": "new-tp-city",
    "address": "新北市三重區中華路89號",
    "phone": "(02) 29820632",
    "illustration": [
      "32李瑞相診所.png"
    ]
  },
  {
    "id": 33,
    "name": "隆安診所",
    "city": "new-tp-city",
    "address": "新北市新莊區龍安路465號",
    "phone": "(02) 22056955",
    "illustration": [
      "33隆安診所.png"
    ]
  },
  {
    "id": 34,
    "name": "林定參診所",
    "city": "new-tp-city",
    "address": "新北市新莊區民安西路211號",
    "phone": "(02) 22070390",
    "illustration": [
      "34林定參診所.png"
    ]
  },
  {
    "id": 35,
    "name": "明新診所",
    "city": "new-tp-city",
    "address": "新北市新莊區建安街109號",
    "phone": "(02) 22043466",
    "illustration": [
      "35明新診所.png"
    ]
  },
  {
    "id": 36,
    "name": "崇文診所",
    "city": "new-tp-city",
    "address": "新北市鶯歌區國慶街141號",
    "phone": "(02) 26783366",
    "illustration": [
      "36崇文診所.png"
    ]
  },
  {
    "id": 37,
    "name": "慈德聯合診所",
    "city": "new-tp-city",
    "address": "新北市鶯歌區國慶街151號",
    "phone": "(02) 26772600",
    "illustration": [
      "37慈德聯合診所.png"
    ]
  },
  {
    "id": 38,
    "name": "怡兒診所",
    "city": "new-tp-city",
    "address": "新北市鶯歌區建國路173號",
    "phone": "(02) 26707200",
    "illustration": [
      "38怡兒診所.png"
    ]
  },
  {
    "id": 39,
    "name": "頂埔中心診所",
    "city": "new-tp-city",
    "address": "新北市土城區中央路四段286號",
    "phone": "(02) 22671382",
    "illustration": [
      "39頂埔中心診所.png"
    ]
  },
  {
    "id": 40,
    "name": "蘇景傑診所",
    "city": "new-tp-city",
    "address": "新北市新店區建國路6號1樓",
    "phone": "(02) 86657771",
    "illustration": [
      "clinics.png"
    ]
  },
  {
    "id": 41,
    "name": "行一昌勲診所",
    "city": "new-tp-city",
    "address": "新北巿新店區北新路212號1樓",
    "phone": "(02) 2918-9212",
    "illustration": [
      "41行一昌勲診所.png"
    ]
  },
  {
    "id": 42,
    "name": "永安診所",
    "city": "new-tp-city",
    "address": "新北市泰山區仁愛路112之2號1樓",
    "phone": "(02) 85318184",
    "illustration": [
      "42永安診所.png"
    ]
  },
  {
    "id": 43,
    "name": "陳正熙診所",
    "city": "new-tp-city",
    "address": "新北市淡水區中山北路一段 87 號",
    "phone": "(02) 26259595",
    "illustration": [
      "43陳正熙診所_1.png",
      "43陳正熙診所_2.png",
      "43陳正熙診所_3.png"
    ]
  },
  {
    "id": 44,
    "name": "周光偉診所",
    "city": "taoyuan-city",
    "address": "桃園市龜山區萬壽路二段1085號",
    "phone": "(03) 3505588",
    "illustration": [
      "44周光偉診所.png"
    ]
  },
  {
    "id": 45,
    "name": "顏福順診所",
    "city": "taoyuan-city",
    "address": "桃園市龜山區山鶯路15號",
    "phone": "(03) 3505638",
    "illustration": [
      "45顏福順診所.png"
    ]
  },
  {
    "id": 46,
    "name": "良祐診所",
    "city": "taoyuan-city",
    "address": "桃園市桃園區南平路518號",
    "phone": "(03) 3166889",
    "illustration": [
      "46良祐診所.png"
    ]
  },
  {
    "id": 47,
    "name": "光文診所",
    "city": "taoyuan-city",
    "address": "桃園市桃園區三民路一段171號",
    "phone": "(03) 3353756",
    "illustration": [
      "47光文診所.png"
    ]
  },
  {
    "id": 48,
    "name": "泰千診所",
    "city": "taoyuan-city",
    "address": "桃園市復興區羅浮村127號",
    "phone": "(03) 3822748",
    "illustration": [
      "clinics.png"
    ]
  },
  {
    "id": 49,
    "name": "陳瑞祥診所",
    "city": "taoyuan-city",
    "address": "桃園市中壢區福州二街475號",
    "phone": "(03) 4616600",
    "illustration": [
      "49陳瑞祥診所.png"
    ]
  },
  {
    "id": 50,
    "name": "同心海華診所",
    "city": "taoyuan-city",
    "address": "桃園市中壢區六和路36號",
    "phone": "0921-775684",
    "illustration": [
      "50同心海華診所.png"
    ]
  },
  {
    "id": 51,
    "name": "聯心診所",
    "city": "taoyuan-city",
    "address": "桃園市中壢區民族路五段310號",
    "phone": "(03) 420-5017",
    "illustration": [
      "51聯心診所.png"
    ]
  },
  {
    "id": 52,
    "name": "敦仁診所",
    "city": "taoyuan-city",
    "address": "桃園市中壢區忠孝路18號",
    "phone": "(03) 4333888",
    "illustration": [
      "52敦仁診所.png"
    ]
  },
  {
    "id": 53,
    "name": "活力診所",
    "city": "taoyuan-city",
    "address": "桃園市中壢區莊敬路160號",
    "phone": "(03) 2713585",
    "illustration": [
      "53活力診所.png"
    ]
  },
  {
    "id": 54,
    "name": "敏昌診所",
    "city": "taoyuan-city",
    "address": "桃園市中壢區福德路32號",
    "phone": "0961-018079",
    "illustration": [
      "54敏昌診所.png"
    ]
  },
  {
    "id": 55,
    "name": "心安診所",
    "city": "taoyuan-city",
    "address": "苗栗縣苗栗市中正路507號",
    "phone": "(03) 7366000",
    "illustration": [
      "55心安診所.png"
    ]
  },
  {
    "id": 56,
    "name": "晨新診所",
    "city": "taoyuan-city",
    "address": "桃園市蘆竹區中正路357號",
    "phone": "(03) 3222232",
    "illustration": [
      "56晨新診所.png"
    ]
  },
  {
    "id": 57,
    "name": "安祐診所",
    "city": "taoyuan-city",
    "address": "桃園市蘆竹區忠孝西路192號",
    "phone": "(03) 2229191",
    "illustration": [
      "57安祐診所.png"
    ]
  },
  {
    "id": 58,
    "name": "姜博文診所",
    "city": "taoyuan-city",
    "address": "桃園市楊梅區永美路335號",
    "phone": "(03) 2714921",
    "illustration": [
      "58姜博文診所.png"
    ]
  },
  {
    "id": 59,
    "name": "民安診所",
    "city": "taoyuan-city",
    "address": "桃園市楊梅區楊新路41號2樓",
    "phone": "(03) 4757681",
    "illustration": [
      "59民安診所.png"
    ]
  },
  {
    "id": 60,
    "name": "嘉誠診所",
    "city": "taoyuan-city",
    "address": "桃園市大園區中華路11號",
    "phone": "(03) 3857929",
    "illustration": [
      "60嘉誠診所.png"
    ]
  },
  {
    "id": 61,
    "name": "維賢診所",
    "city": "taoyuan-city",
    "address": "桃園市平鎮區和平路123號",
    "phone": "(03) 4683636",
    "illustration": [
      "61維賢診所.png"
    ]
  },
  {
    "id": 62,
    "name": "聯恩診所",
    "city": "taoyuan-city",
    "address": "桃園市平鎮區中豐路南勢二段102號",
    "phone": "(03) 4395633",
    "illustration": [
      "62聯恩診所.png"
    ]
  },
  {
    "id": 63,
    "name": "蕭益富診所",
    "city": "taoyuan-city",
    "address": "桃園市八德區大智路5號",
    "phone": "(03) 3675582",
    "illustration": [
      "63蕭益富診所.png"
    ]
  },
  {
    "id": 64,
    "name": "億安診所",
    "city": "hsinchu-city",
    "address": "新竹市東區民族路112號",
    "phone": "(03) 5353256",
    "illustration": [
      "64億安診所.png"
    ]
  },
  {
    "id": 65,
    "name": "康德診所",
    "city": "hsinchu-city",
    "address": "新竹市東區光復路一段362-2號",
    "phone": "(03) 5788282",
    "illustration": [
      "65康德診所.png"
    ]
  },
  {
    "id": 66,
    "name": "林安復耳鼻喉科內科診所",
    "city": "hsinchu-city",
    "address": "新竹市東區中華路二段159號",
    "phone": "(03) 5355890",
    "illustration": [
      "66林安復耳鼻喉科內科診所.png"
    ]
  },
  {
    "id": 67,
    "name": "陳志成耳鼻喉科診所",
    "city": "hsinchu-city",
    "address": "新竹市北區西大路619號",
    "phone": "(03) 5258626",
    "illustration": [
      "67陳志成耳鼻喉科診所.png"
    ]
  },
  {
    "id": 68,
    "name": "德安聯合診所",
    "city": "hsinchu-county",
    "address": "新竹縣竹東鎮長春路二段123號",
    "phone": "(03) 5947345",
    "illustration": [
      "68德安聯合診所.png"
    ]
  },
  {
    "id": 69,
    "name": "平安葉治威聯合診所",
    "city": "hsinchu-county",
    "address": "新竹縣竹東鎮東寧路三段21號",
    "phone": "(03) 5956969",
    "illustration": [
      "69平安葉治威.png"
    ]
  },
  {
    "id": 70,
    "name": "心安診所",
    "city": "miaoli-county",
    "address": "苗栗縣苗栗市中正路507號",
    "phone": "(03) 7366000",
    "illustration": [
      "70心安診所.png"
    ]
  },
  {
    "id": 71,
    "name": "台糖診所",
    "city": "miaoli-county",
    "address": "苗栗縣苗栗市中正路1293號",
    "phone": "(03) 7369147",
    "illustration": [
      "71台糖診所.png"
    ]
  },
  {
    "id": 72,
    "name": "中心診所",
    "city": "miaoli-county",
    "address": "苗栗縣苗栗市中正路632號2樓",
    "phone": "(03) 7358988",
    "illustration": [
      "72中心診所.png"
    ]
  },
  {
    "id": 73,
    "name": "祥安診所",
    "city": "miaoli-county",
    "address": "苗栗縣頭份市中華路928號",
    "phone": "(03) 7667985",
    "illustration": [
      "clinics.png"
    ]
  },
  {
    "id": 74,
    "name": "長安診所",
    "city": "taichung-city",
    "address": "台中市大雅區民興街57號",
    "phone": "(04) 25609988",
    "illustration": [
      "74長安診所.png"
    ]
  },
  {
    "id": 75,
    "name": "淨新診所",
    "city": "taichung-city",
    "address": "台中市潭子區中山路二段391巷5號",
    "phone": "(04) 25333399",
    "illustration": [
      "75淨新診所.png"
    ]
  },
  {
    "id": 76,
    "name": "豐原趙內科診所",
    "city": "taichung-city",
    "address": "台中市豐原區圓環東路615號",
    "phone": "(04) 25200226",
    "illustration": [
      "76豐原趙內科診所.png"
    ]
  },
  {
    "id": 77,
    "name": "林宜民診所",
    "city": "taichung-city",
    "address": "台中市豐原區中山路393號",
    "phone": "(04) 25209199",
    "illustration": [
      "77林宜民診所.png"
    ]
  },
  {
    "id": 78,
    "name": "陳成福診所",
    "city": "taichung-city",
    "address": "台中市豐原區和平街47號",
    "phone": "(04) 25120612",
    "illustration": [
      "78陳成福診所.png"
    ]
  },
  {
    "id": 79,
    "name": "祈安聯合診所",
    "city": "taichung-city",
    "address": "台中市神岡區民生路27號",
    "phone": "(04) 25625470",
    "illustration": [
      "79祈安聯合診所.png"
    ]
  },
  {
    "id": 80,
    "name": "國泰診所",
    "city": "taichung-city",
    "address": "台中市后里區甲后路一段255號",
    "phone": "(04) 25577378",
    "illustration": [
      "80國泰診所.png"
    ]
  },
  {
    "id": 81,
    "name": "中華博士診所",
    "city": "taichung-city",
    "address": "台中市清水區中華路631號",
    "phone": "(04) 26283166",
    "illustration": [
      "81中華博士診所.png"
    ]
  },
  {
    "id": 82,
    "name": "陳瑞明診所",
    "city": "taichung-city",
    "address": "台中市東勢區豐勢路548號",
    "phone": "(04) 25888355",
    "illustration": [
      "clinics.png"
    ]
  },
  {
    "id": 83,
    "name": "琉璃光診所",
    "city": "taichung-city",
    "address": "台中市大甲區順天路342號",
    "phone": "(04) 26873051",
    "illustration": [
      "83琉璃光診所.png"
    ]
  },
  {
    "id": 84,
    "name": "啟恩診所",
    "city": "taichung-city",
    "address": "台中市梧棲區中正里中和街81號",
    "phone": "(04) 26562268",
    "illustration": [
      "84啟恩診所.png"
    ]
  },
  {
    "id": 85,
    "name": "高銘診所",
    "city": "taichung-city",
    "address": "台中市沙鹿區台灣大道七段791號",
    "phone": "(04) 26620286",
    "illustration": [
      "85高銘診所.png"
    ]
  },
  {
    "id": 86,
    "name": "許紋誠診所",
    "city": "taichung-city",
    "address": "台中市沙鹿區中山路539之2號",
    "phone": "(04) 26627282",
    "illustration": [
      "86許紋誠診所.png"
    ]
  },
  {
    "id": 87,
    "name": "永新診所",
    "city": "taichung-city",
    "address": "台中市北屯區松竹路二段159號",
    "phone": "(04) 22467799",
    "illustration": [
      "87永新診所.png"
    ]
  },
  {
    "id": 88,
    "name": "陳建州診所",
    "city": "taichung-city",
    "address": "台中市北屯區昌平路一段176號",
    "phone": "(04) 22307111",
    "illustration": [
      "88陳建州診所.png"
    ]
  },
  {
    "id": 89,
    "name": "佑康診所",
    "city": "taichung-city",
    "address": "台中市北屯區中清路二段586號1樓",
    "phone": "(04) 22923922",
    "illustration": [
      "clinics.png"
    ]
  },
  {
    "id": 90,
    "name": "漢諾威診所",
    "city": "taichung-city",
    "address": "台中市西屯區青海路一段112號",
    "phone": "(04) 23173069",
    "illustration": [
      "90漢諾威診所.png"
    ]
  },
  {
    "id": 91,
    "name": "舒民診所",
    "city": "taichung-city",
    "address": "台中市西屯區福科二路8號",
    "phone": "(04) 24529690",
    "illustration": [
      "91舒民診所.png"
    ]
  },
  {
    "id": 92,
    "name": "王欽耀診所",
    "city": "taichung-city",
    "address": "台中市南屯區忠勇路43之2號",
    "phone": "(04) 23832245",
    "illustration": [
      "92王欽耀診所.png"
    ]
  },
  {
    "id": 93,
    "name": "瑞東診所",
    "city": "taichung-city",
    "address": "台中市南屯區文山三街133巷11號",
    "phone": "(04) 23892301",
    "illustration": [
      "clinics.png"
    ]
  },
  {
    "id": 94,
    "name": "耀隆診所",
    "city": "taichung-city",
    "address": "台中市北區陝西路27-1號",
    "phone": "(04) 22935200",
    "illustration": [
      "94耀隆診所.png"
    ]
  },
  {
    "id": 95,
    "name": "俊霖診所",
    "city": "taichung-city",
    "address": "台中市北區忠明八街32號",
    "phone": "(04) 22085948",
    "illustration": [
      "95俊霖診所.png"
    ]
  },
  {
    "id": 96,
    "name": "博智診所",
    "city": "taichung-city",
    "address": "台中市北區西屯路一段353號",
    "phone": "(04) 23232066",
    "illustration": [
      "96博智診所.png"
    ]
  },
  {
    "id": 97,
    "name": "陳世爵診所",
    "city": "taichung-city",
    "address": "台中市北區英才路386-8號",
    "phone": "(04) 23296088",
    "illustration": [
      "97陳世爵診所.png"
    ]
  },
  {
    "id": 98,
    "name": "白家庭醫學診所",
    "city": "taichung-city",
    "address": "台中市北區益華街62號",
    "phone": "(04) 22354146",
    "illustration": [
      "98白家庭醫學科診所.png"
    ]
  },
  {
    "id": 99,
    "name": "柏羽診所",
    "city": "taichung-city",
    "address": "台中市西區博館路115號",
    "phone": "(04) 23255018",
    "illustration": [
      "99柏羽診所.png"
    ]
  },
  {
    "id": 100,
    "name": "軒宇診所",
    "city": "taichung-city",
    "address": "台中市大里區永隆路11號",
    "phone": "(04) 24067095",
    "illustration": [
      "100軒宇診所.png"
    ]
  },
  {
    "id": 101,
    "name": "劉彥昇診所",
    "city": "taichung-city",
    "address": "台中市大里區健民路83-7號",
    "phone": "(04) 24912812",
    "illustration": [
      "clinics.png"
    ]
  },
  {
    "id": 102,
    "name": "合康診所",
    "city": "taichung-city",
    "address": "台中市霧峰區中正路802-1號",
    "phone": "(04) 23330268",
    "illustration": [
      "clinics.png"
    ]
  },
  {
    "id": 103,
    "name": "鴻安診所",
    "city": "taichung-city",
    "address": "台中市太平區立功路310號",
    "phone": "(04) 23917581",
    "illustration": [
      "103鴻安診所.png"
    ]
  },
  {
    "id": 104,
    "name": "黃建成診所",
    "city": "changhua-county",
    "address": "彰化縣大村鄉茄苳路一段235號",
    "phone": "(04) 8524074",
    "illustration": [
      "104黃建成診所.png"
    ]
  },
  {
    "id": 105,
    "name": "合濟診所",
    "city": "changhua-county",
    "address": "彰化縣北斗鎮中山路二段38號",
    "phone": "(04) 8877995",
    "illustration": [
      "105合濟診所.png"
    ]
  },
  {
    "id": 106,
    "name": "陳嘉烈診所",
    "city": "changhua-county",
    "address": "彰化縣埤頭鄉斗苑西路156號",
    "phone": "(04) 8920222",
    "illustration": [
      "106陳嘉烈診所.png"
    ]
  },
  {
    "id": 107,
    "name": "景新診所",
    "city": "changhua-county",
    "address": "彰化縣社頭鄉清水岩路333號",
    "phone": "(04) 8721227",
    "illustration": [
      "107景新診所.png"
    ]
  },
  {
    "id": 108,
    "name": "南恩內科診所",
    "city": "changhua-county",
    "address": "彰化縣溪湖鎮大溪路二段346號",
    "phone": "(04) 8827009",
    "illustration": [
      "108南恩內科診所.png"
    ]
  },
  {
    "id": 109,
    "name": "十仁診所",
    "city": "changhua-county",
    "address": "彰化縣彰化市辭修路82號",
    "phone": "(04) 7281067",
    "illustration": [
      "109十仁診所.png"
    ]
  },
  {
    "id": 110,
    "name": "順心診所",
    "city": "changhua-county",
    "address": "彰化縣彰化市民生路341號",
    "phone": "(04) 7295295",
    "illustration": [
      "110順心診所.png"
    ]
  },
  {
    "id": 111,
    "name": "慶鴻診所",
    "city": "changhua-county",
    "address": "彰化縣彰化市彰南路二段179號",
    "phone": "(04) 7320068",
    "illustration": [
      "111慶鴻診所_1.png",
      "111慶鴻診所_2.png"
    ]
  },
  {
    "id": 112,
    "name": "謝立偉診所",
    "city": "changhua-county",
    "address": "彰化縣和美鎮道周路720號",
    "phone": "(04) 7568909",
    "illustration": [
      "112謝立偉診所.png"
    ]
  },
  {
    "id": 113,
    "name": "和興聯合診所",
    "city": "changhua-county",
    "address": "彰化縣和美鎮德美路289號",
    "phone": "(04) 7564567",
    "illustration": [
      "113和興聯合診所.png"
    ]
  },
  {
    "id": 114,
    "name": "庚新診所",
    "city": "changhua-county",
    "address": "彰化縣和美鎮糖友一街90號",
    "phone": "(04) 7367095",
    "illustration": [
      "clinics.png"
    ]
  },
  {
    "id": 115,
    "name": "王健龍診所",
    "city": "changhua-county",
    "address": "彰化縣鹿港鎮中山路259號",
    "phone": "(04) 7755188",
    "illustration": [
      "115王健龍診所.png"
    ]
  },
  {
    "id": 116,
    "name": "豐安診所",
    "city": "changhua-county",
    "address": "彰化縣鹿港鎮海浴路11之1號",
    "phone": "(04) 7763711",
    "illustration": [
      "116豐安診所.png"
    ]
  },
  {
    "id": 117,
    "name": "陳宏麟診所",
    "city": "nantou-county",
    "address": "南投縣埔里鎮南昌街221號",
    "phone": "(049) 2900303",
    "illustration": [
      "117陳宏麟診所.png"
    ]
  },
  {
    "id": 118,
    "name": "許瑞娟診所",
    "city": "nantou-county",
    "address": "南投縣埔里鎮西安路一段80號",
    "phone": "(049) 2990289",
    "illustration": [
      "118許瑞娟診所.png"
    ]
  },
  {
    "id": 119,
    "name": "安杏診所",
    "city": "nantou-county",
    "address": "南投縣埔里鎮中山路三段100號",
    "phone": "(049) 2980445",
    "illustration": [
      "119安杏診所.png"
    ]
  },
  {
    "id": 120,
    "name": "黎俊奇診所",
    "city": "nantou-county",
    "address": "南投縣埔里鎮中正路464號",
    "phone": "(049) 2999576",
    "illustration": [
      "120黎俊奇診所.png"
    ]
  },
  {
    "id": 121,
    "name": "尚德診所",
    "city": "nantou-county",
    "address": "南投縣草屯鎮自由街134巷24號",
    "phone": "(049) 2381800",
    "illustration": [
      "clinics.png"
    ]
  },
  {
    "id": 122,
    "name": "錦林診所",
    "city": "nantou-county",
    "address": "南投縣草屯鎮虎山路736號",
    "phone": "(049) 2357509",
    "illustration": [
      "122錦林診所.png"
    ]
  },
  {
    "id": 123,
    "name": "洪啟芬診所",
    "city": "nantou-county",
    "address": "南投縣草屯鎮中正路1222號",
    "phone": "(049) 2553359",
    "illustration": [
      "123洪啟芬診所.png"
    ]
  },
  {
    "id": 124,
    "name": "蔡良迪診所",
    "city": "nantou-county",
    "address": "南投縣南投市中學西路85號",
    "phone": "(049) 2391296",
    "illustration": [
      "124蔡良迪診所.png"
    ]
  },
  {
    "id": 125,
    "name": "謝明哲診所",
    "city": "nantou-county",
    "address": "南投縣竹山鎮集山路三段816之2號",
    "phone": "(049) 2660583",
    "illustration": [
      "clinics.png"
    ]
  },
  {
    "id": 126,
    "name": "石龜溪診所",
    "city": "yunlin-county",
    "address": "雲林縣斗南鎮中和路50號",
    "phone": "(05) 5979438",
    "illustration": [
      "126石龜溪診所.png"
    ]
  },
  {
    "id": 127,
    "name": "腎安診所",
    "city": "yunlin-county",
    "address": "雲林縣虎尾鎮光復路360號",
    "phone": "(05) 6330133",
    "illustration": [
      "clinics.png"
    ]
  },
  {
    "id": 128,
    "name": "虎尾台全診所",
    "city": "yunlin-county",
    "address": "雲林縣虎尾鎮林森路一段346號",
    "phone": "(05) 6366111",
    "illustration": [
      "clinics.png"
    ]
  },
  {
    "id": 129,
    "name": "曾良達診所",
    "city": "chiayi-city",
    "address": "嘉義市西區八德路338號",
    "phone": "(05) 2333928",
    "illustration": [
      "129曾良達診所.png"
    ]
  },
  {
    "id": 130,
    "name": "洪瑞禧診所",
    "city": "chiayi-city",
    "address": "嘉義市西區林森西路552號",
    "phone": "(05) 2293506",
    "illustration": [
      "130洪瑞禧診所.png"
    ]
  },
  {
    "id": 131,
    "name": "王國哲診所",
    "city": "chiayi-city",
    "address": "嘉義市西區博愛路二段359號",
    "phone": "(05) 2310550",
    "illustration": [
      "131王國哲診所.png"
    ]
  },
  {
    "id": 132,
    "name": "黃彬診所",
    "city": "chiayi-city",
    "address": "嘉義市西區博愛路一段411之3號",
    "phone": "(05) 2333380",
    "illustration": [
      "132黃彬診所.png"
    ]
  },
  {
    "id": 133,
    "name": "開心診所",
    "city": "chiayi-city",
    "address": "嘉義市西區玉山路182號",
    "phone": "(05) 2357182",
    "illustration": [
      "133開心診所.png"
    ]
  },
  {
    "id": 134,
    "name": "黃銘模診所",
    "city": "chiayi-city",
    "address": "嘉義市東區中正路374號",
    "phone": "(05) 2247873",
    "illustration": [
      "134黃銘模診所.png"
    ]
  },
  {
    "id": 135,
    "name": "劉耳鼻喉科診所",
    "city": "chiayi-city",
    "address": "嘉義市東區民權路322之2號",
    "phone": "(05) 2786915",
    "illustration": [
      "135耳鼻喉科診所.png"
    ]
  },
  {
    "id": 136,
    "name": "安家診所",
    "city": "chiayi-city",
    "address": "嘉義市東區台林街221號",
    "phone": "(05) 2775367",
    "illustration": [
      "136安家診所_1.png",
      "136安家診所_2.png"
    ]
  },
  {
    "id": 137,
    "name": "陳霆昌安糖診所",
    "city": "chiayi-county",
    "address": "嘉義縣大林鎮四維街22號",
    "phone": "(05) 2648169",
    "illustration": [
      "137陳霆昌安糖診所.png"
    ]
  },
  {
    "id": 138,
    "name": "國泰診所",
    "city": "chiayi-county",
    "address": "嘉義縣民雄鄉福樂村埤角519號1樓",
    "phone": "(05) 2215260",
    "illustration": [
      "clinics.png"
    ]
  },
  {
    "id": 139,
    "name": "台大佳醫診所",
    "city": "chiayi-county",
    "address": "嘉義縣中埔鄉34之51號",
    "phone": "(05) 2399199",
    "illustration": [
      "139台大佳醫診所.png"
    ]
  },
  {
    "id": 140,
    "name": "三愛診所",
    "city": "tainan-city",
    "address": "台南市永康區復國路62號1F",
    "phone": "(06) 3130970",
    "illustration": [
      "clinics.png"
    ]
  },
  {
    "id": 141,
    "name": "永慶診所",
    "city": "tainan-city",
    "address": "台南市永康區復國一路198號",
    "phone": "(06) 3133996",
    "illustration": [
      "clinics.png"
    ]
  },
  {
    "id": 142,
    "name": "大橋誠康診所",
    "city": "tainan-city",
    "address": "台南市永康區大橋二街180號",
    "phone": "(06) 3029119",
    "illustration": [
      "142大橋誠康診所.png"
    ]
  },
  {
    "id": 143,
    "name": "成美診所",
    "city": "tainan-city",
    "address": "台南市永康區中山南路166號",
    "phone": "(06) 3039028",
    "illustration": [
      "143成美診所.png"
    ]
  },
  {
    "id": 144,
    "name": "周劍文診所",
    "city": "tainan-city",
    "address": "台南市永康區小東路423巷2號",
    "phone": "(06) 3110218",
    "illustration": [
      "144周劍文診所.png"
    ]
  },
  {
    "id": 145,
    "name": "怡人診所",
    "city": "tainan-city",
    "address": "台南市永康區復興路15號",
    "phone": "(06) 2020777",
    "illustration": [
      "145怡人診所.png"
    ]
  },
  {
    "id": 146,
    "name": "顏大翔內科診所",
    "city": "tainan-city",
    "address": "台南市永康區大灣路868號",
    "phone": "(06) 2730320",
    "illustration": [
      "146顏大翔內科診所.png"
    ]
  },
  {
    "id": 147,
    "name": "永德康內科診所",
    "city": "tainan-city",
    "address": "台南市永康區中山路118號",
    "phone": "(06) 2032258",
    "illustration": [
      "147永德康內科診所.png"
    ]
  },
  {
    "id": 148,
    "name": "大灣健全診所",
    "city": "tainan-city",
    "address": "台南市永康區大灣路276號",
    "phone": "(06) 2739652",
    "illustration": [
      "148大灣健全診所.png"
    ]
  },
  {
    "id": 149,
    "name": "楊寧娟內科診所",
    "city": "tainan-city",
    "address": "台南市永康區大灣路798巷12號",
    "phone": "(06) 2721231",
    "illustration": [
      "clinics.png"
    ]
  },
  {
    "id": 150,
    "name": "亮心診所",
    "city": "tainan-city",
    "address": "台南市永康區振興路50號",
    "phone": "(06) 3035160",
    "illustration": [
      "clinics.png"
    ]
  },
  {
    "id": 151,
    "name": "朱嘉生診所",
    "city": "tainan-city",
    "address": "台南市安南區城北里安中路六段620號",
    "phone": "(06) 2573180",
    "illustration": [
      "151朱嘉生診所.png"
    ]
  },
  {
    "id": 152,
    "name": "李聰明內科診所",
    "city": "tainan-city",
    "address": "台南市安南區長和路一段501號",
    "phone": "(06) 3966800",
    "illustration": [
      "152李聰明內科診所.png"
    ]
  },
  {
    "id": 153,
    "name": "陽光小兒科診所",
    "city": "tainan-city",
    "address": "台南市安平區華平路501號",
    "phone": "(06) 2937711",
    "illustration": [
      "153陽光小兒科診所.png"
    ]
  },
  {
    "id": 154,
    "name": "喜恩診所",
    "city": "tainan-city",
    "address": "台南市安平區永華路二段571號",
    "phone": "(06) 2933566",
    "illustration": [
      "154喜恩診所.png"
    ]
  },
  {
    "id": 155,
    "name": "陳清煌診所",
    "city": "tainan-city",
    "address": "台南市善化區中山路296號",
    "phone": "(06) 5831450",
    "illustration": [
      "clinics.png"
    ]
  },
  {
    "id": 156,
    "name": "明翔診所",
    "city": "tainan-city",
    "address": "台南市善化區中山路350號",
    "phone": "(06) 3110218",
    "illustration": [
      "clinics.png"
    ]
  },
  {
    "id": 157,
    "name": "崇祐聯合診所",
    "city": "tainan-city",
    "address": "台南市新化區忠孝路285號",
    "phone": "(06) 5980342",
    "illustration": [
      "clinics.png"
    ]
  },
  {
    "id": 158,
    "name": "張士澎診所",
    "city": "tainan-city",
    "address": "台南市南區西門路一段611號",
    "phone": "(06) 2216216",
    "illustration": [
      "clinics.png"
    ]
  },
  {
    "id": 159,
    "name": "達俊診所",
    "city": "tainan-city",
    "address": "台南市東區青年路434號",
    "phone": "(06) 2361337",
    "illustration": [
      "159達俊診所.png"
    ]
  },
  {
    "id": 160,
    "name": "陳煌奇耳鼻喉科診所",
    "city": "tainan-city",
    "address": "台南市東區崇學路271之4號",
    "phone": "(06) 2680472",
    "illustration": [
      "clinics.png"
    ]
  },
  {
    "id": 161,
    "name": "游新診所",
    "city": "tainan-city",
    "address": "台南市中西區健康路一段370號",
    "phone": "(06) 2149009",
    "illustration": [
      "161游新診所.png"
    ]
  },
  {
    "id": 162,
    "name": "張富全診所",
    "city": "tainan-city",
    "address": "台南市中西區永華路一段198號",
    "phone": "(06) 2220516",
    "illustration": [
      "clinics.png"
    ]
  },
  {
    "id": 163,
    "name": "忠群診所",
    "city": "tainan-city",
    "address": "台南市中西區民生路二段403號",
    "phone": "(06) 2280808",
    "illustration": [
      "clinics.png"
    ]
  },
  {
    "id": 164,
    "name": "吳世安陳沛仁聯合診所",
    "city": "tainan-city",
    "address": "台南市歸仁區民族北街17巷6號",
    "phone": "(06) 2393396",
    "illustration": [
      "164吳世安陳沛仁聯合診所.png"
    ]
  },
  {
    "id": 165,
    "name": "懷仁內科診所",
    "city": "tainan-city",
    "address": "台南市歸仁區中山路一段530號",
    "phone": "(06) 2303995",
    "illustration": [
      "165懷仁內科診所.png"
    ]
  },
  {
    "id": 166,
    "name": "周書澤內科診所",
    "city": "tainan-city",
    "address": "台南市新營區民治路352號",
    "phone": "(06) 6591010",
    "illustration": [
      "clinics.png"
    ]
  },
  {
    "id": 167,
    "name": "郭昇峯內科診所",
    "city": "tainan-city",
    "address": "台南市新營區民治路322號",
    "phone": "(06) 6567928",
    "illustration": [
      "clinics.png"
    ]
  },
  {
    "id": 168,
    "name": "晨祐診所",
    "city": "tainan-city",
    "address": "台南市下營區中正南路55號",
    "phone": "(06) 6892525",
    "illustration": [
      "clinics.png"
    ]
  },
  {
    "id": 169,
    "name": "華夏診所",
    "city": "kaohsiung-city",
    "address": "高雄市左營區華夏路708號1樓",
    "phone": "(07) 3453961",
    "illustration": [
      "169華夏診所.png"
    ]
  },
  {
    "id": 170,
    "name": "吉泰內科診所",
    "city": "kaohsiung-city",
    "address": "高雄市前鎮區保泰路419號",
    "phone": "(07) 7616000",
    "illustration": [
      "170吉泰內科診所.png"
    ]
  },
  {
    "id": 171,
    "name": "維康診所",
    "city": "kaohsiung-city",
    "address": "高雄市前鎮區鄭和路45號",
    "phone": "(07) 3345373",
    "illustration": [
      "171維康診所.png"
    ]
  },
  {
    "id": 172,
    "name": "陳顯明診所",
    "city": "kaohsiung-city",
    "address": "高雄市楠梓區德賢路265號",
    "phone": "(07) 3648127",
    "illustration": [
      "172陳顯明診所.png"
    ]
  },
  {
    "id": 173,
    "name": "歐慈德內科診所",
    "city": "kaohsiung-city",
    "address": "高雄市楠梓區後昌路915號",
    "phone": "(07) 3633900",
    "illustration": [
      "173歐慈德內科診所.png"
    ]
  },
  {
    "id": 174,
    "name": "小太陽診所",
    "city": "kaohsiung-city",
    "address": "高雄市美濃區成功路219-1號",
    "phone": "(07) 6812332",
    "illustration": [
      "174小太陽診所.png"
    ]
  },
  {
    "id": 175,
    "name": "大政診所",
    "city": "kaohsiung-city",
    "address": "高雄市旗山區延平一路337號",
    "phone": "(07) 6622588",
    "illustration": [
      "175大政診所.png"
    ]
  },
  {
    "id": 176,
    "name": "聖星診所",
    "city": "kaohsiung-city",
    "address": "高雄市旗山區延平一路689號",
    "phone": "(07) 6622555",
    "illustration": [
      "176聖星診所.png"
    ]
  },
  {
    "id": 177,
    "name": "董石城診所",
    "city": "kaohsiung-city",
    "address": "高雄市鳳山區文龍東路353號",
    "phone": "(07) 7407636",
    "illustration": [
      "clinics.png"
    ]
  },
  {
    "id": 178,
    "name": "大欣診所",
    "city": "kaohsiung-city",
    "address": "高雄市鳳山區文化路25號",
    "phone": "(07) 7993009",
    "illustration": [
      "clinics.png"
    ]
  },
  {
    "id": 179,
    "name": "大欣診所",
    "city": "kaohsiung-city",
    "address": "高雄市鳳山區文化路25號",
    "phone": "(07) 7993009",
    "illustration": [
      "clinics.png"
    ]
  },
  {
    "id": 180,
    "name": "文山診所",
    "city": "kaohsiung-city",
    "address": "高雄市鳳山區建國路三段157號",
    "phone": "(07) 7107010",
    "illustration": [
      "180文山診所.png"
    ]
  },
  {
    "id": 181,
    "name": "好心診所",
    "city": "kaohsiung-city",
    "address": "高雄市鳳山區文濱路196號",
    "phone": "(07) 7676688",
    "illustration": [
      "clinics.png"
    ]
  },
  {
    "id": 182,
    "name": "建工萬川診所",
    "city": "kaohsiung-city",
    "address": "高雄市三民區建工路539號1樓",
    "phone": "(07) 3808878",
    "illustration": [
      "182建工萬川診所.png"
    ]
  },
  {
    "id": 183,
    "name": "青聯診所",
    "city": "kaohsiung-city",
    "address": "高雄市三民區文濱路31號",
    "phone": "(07) 7677002",
    "illustration": [
      "183青聯診所.png"
    ]
  },
  {
    "id": 184,
    "name": "川惠診所",
    "city": "kaohsiung-city",
    "address": "高雄市三民區文安南街78號",
    "phone": "(07) 7807811",
    "illustration": [
      "184 川惠診所.png"
    ]
  },
  {
    "id": 185,
    "name": "鼎山診所",
    "city": "kaohsiung-city",
    "address": "高雄市三民區鼎華路12號",
    "phone": "(07) 3800000",
    "illustration": [
      "185鼎山診所.png"
    ]
  },
  {
    "id": 186,
    "name": "元成診所",
    "city": "kaohsiung-city",
    "address": "高雄市三民區陽明路81號",
    "phone": "(07) 3903808",
    "illustration": [
      "186元成診所.png"
    ]
  },
  {
    "id": 187,
    "name": "晶品診所",
    "city": "kaohsiung-city",
    "address": "高雄市三民區十全一路16號",
    "phone": "(07) 3222517",
    "illustration": [
      "187晶品診所.png"
    ]
  },
  {
    "id": 188,
    "name": "健維診所",
    "city": "kaohsiung-city",
    "address": "高雄市苓雅區福建街25號",
    "phone": "(07) 3344637",
    "illustration": [
      "clinics.png"
    ]
  },
  {
    "id": 189,
    "name": "為好診所",
    "city": "kaohsiung-city",
    "address": "高雄市鼓山區九如四路957號",
    "phone": "(07) 5215489",
    "illustration": [
      "189為好診所.png"
    ]
  },
  {
    "id": 190,
    "name": "尚恆內科診所",
    "city": "kaohsiung-city",
    "address": "高雄市鼓山區龍勝路120號",
    "phone": "(07) 5225295",
    "illustration": [
      "190尚恆內科診所.png"
    ]
  },
  {
    "id": 191,
    "name": "辰好診所",
    "city": "kaohsiung-city",
    "address": "高雄市小港區漢民路220號",
    "phone": "(07) 8010893",
    "illustration": [
      "191辰好診所.png"
    ]
  },
  {
    "id": 192,
    "name": "鳳林診所",
    "city": "kaohsiung-city",
    "address": "高雄市小港區鳳林路93之1號",
    "phone": "(07) 8720822",
    "illustration": [
      "clinics.png"
    ]
  },
  {
    "id": 193,
    "name": "漢民好心診所",
    "city": "kaohsiung-city",
    "address": "高雄市小港區山明路178號",
    "phone": "(07) 8012121",
    "illustration": [
      "clinics.png"
    ]
  },
  {
    "id": 194,
    "name": "孔鳳診所",
    "city": "kaohsiung-city",
    "address": "高雄市小港區孔鳳路571號",
    "phone": "(07) 7910311",
    "illustration": [
      "clinics.png"
    ]
  },
  {
    "id": 195,
    "name": "大嘉診所",
    "city": "kaohsiung-city",
    "address": "高雄市六龜區太平路114號",
    "phone": "(07) 6895789",
    "illustration": [
      "195大嘉診所.png"
    ]
  },
  {
    "id": 196,
    "name": "祐民診所",
    "city": "kaohsiung-city",
    "address": "高雄市路竹區中和街180號",
    "phone": "(07) 6072211",
    "illustration": [
      "196祐民診所.png"
    ]
  },
  {
    "id": 197,
    "name": "健和診所",
    "city": "kaohsiung-city",
    "address": "高雄市新興區五福一路140之一號",
    "phone": "(07) 2299968",
    "illustration": [
      "197健和診所.png"
    ]
  },
  {
    "id": 198,
    "name": "兆信內科診所",
    "city": "kaohsiung-city",
    "address": "高雄市新興區中正四路53號1樓",
    "phone": "(07) 2810108",
    "illustration": [
      "198兆信內科診所.png"
    ]
  },
  {
    "id": 199,
    "name": "宏祐診所",
    "city": "kaohsiung-city",
    "address": "高雄市前金區中正四路124號",
    "phone": "(07) 2856777",
    "illustration": [
      "199宏祐診所.png"
    ]
  },
  {
    "id": 200,
    "name": "仁武好心診所",
    "city": "kaohsiung-city",
    "address": "高雄市仁武區中正路301號",
    "phone": "(07) 3719895",
    "illustration": [
      "200仁武好心診所.png"
    ]
  },
  {
    "id": 201,
    "name": "張桐榮診所",
    "city": "kaohsiung-city",
    "address": "高雄市大寮區鳳林三路573號",
    "phone": "(07) 7825382",
    "illustration": [
      "clinics.png"
    ]
  },
  {
    "id": 202,
    "name": "梁宏志診所",
    "city": "pingtung-county",
    "address": "屏東縣屏東市自由路381號",
    "phone": "(08) 7364494",
    "illustration": [
      "202梁宏志診所.png"
    ]
  },
  {
    "id": 203,
    "name": "振成診所",
    "city": "pingtung-county",
    "address": "屏東縣屏東市林森路60號",
    "phone": "(08) 7322660",
    "illustration": [
      "203振成診所.png"
    ]
  },
  {
    "id": 204,
    "name": "曾競鋒診所",
    "city": "pingtung-county",
    "address": "屏東縣屏東市廣東路1020號",
    "phone": "(08) 7324355",
    "illustration": [
      "204曾競鋒診所.png"
    ]
  },
  {
    "id": 205,
    "name": "李洮俊診所",
    "city": "pingtung-county",
    "address": "屏東縣屏東市民族路130號",
    "phone": "(08) 7668901",
    "illustration": [
      "205李洮俊診所.png"
    ]
  },
  {
    "id": 206,
    "name": "芯禾診所",
    "city": "pingtung-county",
    "address": "屏東縣屏東市青島街135號",
    "phone": "(08) 7321060",
    "illustration": [
      "206芯禾診所.png"
    ]
  },
  {
    "id": 207,
    "name": "洮俊診所",
    "city": "pingtung-county",
    "address": "屏東縣屏東市廣東路396號",
    "phone": "(08) 7362794",
    "illustration": [
      "207洮俊診所.png"
    ]
  },
  {
    "id": 208,
    "name": "楊樂濱診所",
    "city": "pingtung-county",
    "address": "屏東縣春日鄉春日路2號",
    "phone": "(08) 8787856",
    "illustration": [
      "208楊樂濱診所.png"
    ]
  },
  {
    "id": 209,
    "name": "杏元診所",
    "city": "pingtung-county",
    "address": "屏東縣高樹鄉南興路58之1號",
    "phone": "(08) 7967788",
    "illustration": [
      "209杏元診所.png"
    ]
  },
  {
    "id": 210,
    "name": "里港晨安診所",
    "city": "pingtung-county",
    "address": "屏東縣里港鄉中山路94號",
    "phone": "(08) 7756111",
    "illustration": [
      "210里港晨安診所.png"
    ]
  },
  {
    "id": 211,
    "name": "昭仁診所",
    "city": "pingtung-county",
    "address": "屏東縣內埔鄉廣濟路257號",
    "phone": "(08) 7782312",
    "illustration": [
      "clinics.png"
    ]
  },
  {
    "id": 212,
    "name": "真善美診所",
    "city": "pingtung-county",
    "address": "屏東縣潮州鎮榮祥路90號",
    "phone": "(08) 7895123",
    "illustration": [
      "212真善美診所.png"
    ]
  },
  {
    "id": 213,
    "name": "王尹星診所",
    "city": "pingtung-county",
    "address": "屏東縣潮州鎮朝昇路267號",
    "phone": "(08) 7800258",
    "illustration": [
      "213王尹星診所.png"
    ]
  },
  {
    "id": 214,
    "name": "開蘭安心診所",
    "city": "yilan-county",
    "address": "宜蘭縣宜蘭市神農路一段97號",
    "phone": "(03) 9311230",
    "illustration": [
      "214開蘭安心診所.png"
    ]
  },
  {
    "id": 215,
    "name": "陳煥文內科診所",
    "city": "yilan-county",
    "address": "宜蘭縣羅東鎮公正路118號",
    "phone": "(03) 9577678",
    "illustration": [
      "215陳煥文內科診所.png"
    ]
  },
  {
    "id": 216,
    "name": "林聰源診所",
    "city": "yilan-county",
    "address": "宜蘭縣冬山鄉義成路二段375號",
    "phone": "(03) 9582772",
    "illustration": [
      "216林聰源診所.png"
    ]
  },
  {
    "id": 217,
    "name": "國泰聯合診所",
    "city": "hualien-county",
    "address": "花蓮縣花蓮市中正路194號",
    "phone": "(03) 8542031",
    "illustration": [
      "217花蓮國泰聯合診所.png"
    ]
  },
  {
    "id": 218,
    "name": "黃信揚診所",
    "city": "taitung-county",
    "address": "台東縣台東市南京路135號",
    "phone": "(08) 9350385",
    "illustration": [
      "218黃信揚診所.png"
    ]
  }
]
}
export default data;